
<template>
    <main :class="[isLight ? 'lightmode' : 'darkmode']">
        <h1>Time unit convertion</h1>
        <form @submit.prevent="convert" :class="[isLight ? 'lightmode' : 'darkmode']">
            <label id="value-lbl" for="value">Value:</label><input type="number" id="value" :class="[isLight ? 'lightmode' : 'darkmode']" v-model.number="inputVal"/>
            <label for="from-select" id="from-lbl">From</label><label for="to-select" id="to-lbl">To</label>
            <select id="from-select" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="fromSelectIndex">
                <option v-for="unit in units" :key="unit.name" :value="unit.value">{{ unit.name }}</option>
            </select>
            <button type="button" id="swap-selects" :class="[isLight ? 'lightmode' : 'darkmode']" @click="switchIndices">⇆</button>
            <select id="to-select" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="toSelectIndex">
                <option v-for="unit in units" :key="unit.name" :value="unit.value">{{ unit.name }}</option>
            </select>
            <button type="submit" id="calculate" :class="[isLight ? 'lightmode' : 'darkmode']">Convert</button>
            <fieldset>
                <legend>Result</legend>
                <output :class="[formSubmitted ? '' : 'not-submitted',isLight ? 'lightmode' : 'darkmode']">{{ resultlbl }}</output>
            </fieldset>
        </form>
    </main>
</template>

<script setup>
    import { ref,toRef,defineProps } from 'vue';

    const props = defineProps({
        darkMode:Boolean
    });

    var isLight = toRef(props,'darkMode');

    var fromSelectIndex = ref(0);
    var toSelectIndex = ref(1);
    var formSubmitted = ref(false);
    var resultlbl = ref("Result");
    var inputVal = ref(0);

    const units = [{value:0,name:"Seconds",base:1},{value:1,name:"Minutes",base:60},{value:2,name:"Hours",base:3600},
                   {value:3,name:"Days",base:86400},{value:4,name:"Weeks",base:604800},{value:5,name:"Months",base:2629746},
                   {value:6,name:"Years",base:31556952},{value:7,name:"Centuries",base:3155695200},
                   {value:8,name:"Milliseconds",base:0.001},{value:9,name:"Microseconds",base:0.000001},
                   {value:10,name:"Nanoseconds",base:0.000000001},{value:11,name:"Time Units",base:0.001024},
                   {value:12,name:"Electronics jiffy",base:0.01666666},{value:13,name:"Decimal seconds",base:0.864},
                   {value:14,name:"Decimal minutes",base:86.4},{value:15,name:"Decimal hours",base:8640},
                   {value:16,name:"Decimal days",base:86400},{value:17,name:"Work days",base:28800},
                   {value:18,name:"Quarters",base:7884864}];

    const switchIndices = () =>
    {
        const temp = fromSelectIndex.value;
        fromSelectIndex.value = toSelectIndex.value;
        toSelectIndex.value = temp;
    }

    const convert = () =>
    {
        formSubmitted.value = true;
        const fromBase = units[fromSelectIndex.value].base;
        const toBase = units[toSelectIndex.value].base;
        const inputInSec = inputVal.value*fromBase;
        let result = inputInSec/toBase;
        if(Math.abs(result) > 1) result = Number(result.toFixed(2));
        resultlbl.value = inputVal.value + " " + units[fromSelectIndex.value].name + " = " + result + " " + units[toSelectIndex.value].name;
    }
</script>

<style scoped>
    main
    {
        grid-area: 2 / 1 / 3 / 2;
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        font-family: Syne;
        width:92%;
        height:fit-content;
        max-width: 600px;
        padding:2% 4%;
        margin:30px auto;
        border-radius: 12px;
    }

    main.lightmode
    {
        background-color: #F7F7F6;
        color:#2b3133;
        box-shadow:#2b3133 0px 1px 7px 1px;
        -webkit-box-shadow:#2b3133 0px 1px 7px 1px;
    }

    main.darkmode
    {
        background-color: #2b3133;
        color: #F7F7F6;
        box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
        -webkit-box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
    }

    form
    {
        display:grid;
        grid-template-rows: 0px 30px 24px 40px 50px auto;
        grid-template-columns: minmax(0,2fr) minmax(0,1fr) minmax(0,2fr);
        max-width:500px;
        justify-self: center;
    }

    form.lightmode,main.lightmode
    {
        color:#2b3133;
    }

    form.darkmode,main.darkmode
    {
        color:#F7F7F6;
    }

    h1
    {
        margin:0;
        justify-self: center;
        align-self: center;
        cursor:default;
        font-size: clamp(1rem,18vw - 1rem,1.5rem);
    }

    label#value-lbl,input[type=number]
    {
        font-size: 25px;
        align-self: center;
    }

    label#value-lbl
    {
        grid-area: 2 / 1 / 3 / 2;
        justify-self: right;
        user-select: none;
    }

    input[type=number]
    {
        grid-area: 2 / 2 / 3 / -1;
        width:calc(500px * (3/5) * 0.75);
        max-width:95%;
        justify-self: left;
        border-radius: 10px;
        border:1px solid #2b3133;
        font-family: Syne;
        text-indent: 10px;
    }

    input[type=number].lightmode
    {
        color:#2b3133;
        background-color: #F7F7F6;
    }

    input[type=number].darkmode
    {
        color:#F7F7F6;
        background-color: #202526;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button
    {
        appearance: none;
        -webkit-appearance: none;
    }

    input:focus,select:focus
    {
        outline: none;
    }

    label#from-lbl,label#to-lbl
    {
        font-size: 20px;
        align-self: center;
        user-select: none;
    }

    label#from-lbl
    {
        grid-area: 3 / 1 / 4 / 2;
        justify-self: right;
        padding-right:10px;
    }

    label#to-lbl
    {
        grid-area: 3 / 3 / 4 / 4;
        justify-self: left;
        padding-left:10px;
    }

    button#swap-selects
    {
        grid-area: 4 / 2 / 5 / 3;
        background: none;
        border:none;
        font-size: 40px;
        height:45px;
        justify-self: center;
        align-self: center;
        padding:0;
    }

    button#swap-selects.lightmode
    {
        color:#7f8d92;
    }

    button#swap-selects.darkmode
    {
        color:#F7F7F6;
    }

    select
    {
        width:90%;
        font-size: 24px;
        font-family: Syne;
        align-self: center;
        height:80%;
        appearance:none;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 8px;
        border-radius: 12px;
        text-overflow:ellipsis;
        border:1px solid #2b3133;
    }

    select.lightmode
    {
        color:#2b3133;
        background-color: #F7F7F6;
    }

    select.darkmode
    {
        color:#F7F7F6;
        background-color: #202526;
    }

    select#from-select
    {
        grid-area: 4 / 1 / 5 / 2;
        justify-self: right;
    }

    select#to-select
    {
        grid-area: 4 / 3 / 5 / -1;
    }

    button#calculate
    {
        grid-area: 5 / 1 / 6 / -1;
        justify-self: center;
        align-self: center;
        font-family: Syne;
        font-size: 24px;
        padding:12px;
        border:none;
        border-radius: 20px;
    }

    button#calculate.lightmode
    {
        background-color: #1DCD9F;
        color:#F7F7F6;
    }

    button#calculate.darkmode
    {
        background-color: #328E6E;
        color:#F7F7F6;
    }

    button#calculate:hover
    {
        text-decoration: underline;
    }

    select,button
    {
        cursor: pointer;
    }

    fieldset
    {
        grid-area: 6 / 1 / -1 / -1;
        height:100px;
        border-radius: 8px;
        height:fit-content;
    }

    output
    {
        font-size: 40px;
        justify-self: center;
        padding:6px;
        word-break: break-word;
        overflow-wrap: anywhere;
    }

    output.not-submitted.lightmode,output.darkmode
    {
        color:#F7F7F6;
    }

    output.not-submitted.darkmode,output.lightmode
    {
        color:#2b3133;
    }
</style>